<div class="container">
    <h2 class="title">Filtres avancés</h2>
    <div class="horizontal-separator"></div>
    <div class="tv-container-select-white-rect-extensible full-width">
        <mat-form-field>
            <mat-label>Choisissez votre filtre</mat-label>
            <mat-select panelClass="tv-custom-always-visible-scroll-bar" [formControl]="selectedFilter">
                <mat-option class="tv-ns-select-option" *ngFor="let filter of filtersType" [value]="filter">{{ filter.name }}</mat-option>
            </mat-select>
            <mat-hint></mat-hint>
        </mat-form-field>
    </div>
    <div [formGroup]="filtersForm" class="filters-form-container">
        <div *ngIf="selectedFilter.value.id === 0">
            <mat-chip-set class="tv-chip-light-round" formControlName="type">
                <ng-container *ngFor="let type of screenTypePresence">
                    <mat-chip [disabled]="!type.presence" (click)="selectTypeFilter(type)">
                        <p>{{ type.name }}</p>
                        <mat-icon *ngIf="this.typeFilters.includes(type.name)" class="small-icon">done</mat-icon>
                    </mat-chip>
                </ng-container>
            </mat-chip-set>
        </div>

        <div *ngIf="selectedFilter.value.id === 1" class="tv-rect-input-extensible full-width">
            <mat-form-field>
                <mat-label>Saisissez un calibrage</mat-label>
                <input matInput formControlName="duration" />
            </mat-form-field>
        </div>

        <div formGroupName="entitled" *ngIf="selectedFilter.value.id === 2" class="operator-value-wrapper">
            <div class="tv-container-select-white-rect-extensible full-width">
                <mat-form-field>
                    <mat-label>Opérateur</mat-label>
                    <mat-select panelClass="tv-custom-always-visible-scroll-bar" formControlName="operator">
                        <mat-option class="tv-ns-select-option" *ngFor="let operator of operatorType" [value]="operator.name">{{
                            operator.name
                        }}</mat-option>
                    </mat-select>
                    <mat-hint></mat-hint>
                </mat-form-field>
            </div>

            <div class="tv-rect-input-extensible full-width">
                <mat-form-field>
                    <mat-label>Fin d'intitulé en chiffres</mat-label>
                    <input matInput formControlName="minuteControl" />
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="action-button-check-container">
        <mat-checkbox class="tv-ns-blue-checkbox margin-right" [checked]="this.data?.preserveFilters" [formControl]="preserveFilters">
            Conserver les filtres
        </mat-checkbox>
        <div class="action-button">
            <button (click)="close()" class="tv-ns-secondary-large-button-on-light-bg">Annuler</button>

            <button (click)="submit()" class="tv-ns-validation-large-button">
                Valider
                <mat-icon class="small-icon">done</mat-icon>
            </button>
        </div>
    </div>
</div>
